import { Component, EventEmitter, Input, Output } from '@angular/core'
import { DateFormatService } from 'dmmp-services'

@Component({
  selector: 'dmmp-press-room',
  templateUrl: './press-room.component.html',
})
export class PressRoomComponent {

  @Input() data: any
  @Input() identifier: string
  @Output() page = new EventEmitter()

  constructor(public dateFormatService: DateFormatService) {
  }
}
